// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-664502f0] .el-dialog {\n  max-width: 700px;\n}\n[data-v-664502f0] .el-dialog__body {\n  margin-bottom: -20px;\n}", ""]);
// Exports
module.exports = exports;
